import blackJack from "../assets/img/blackjack.avif"
import cyberChat from "../assets/img/ciberchat.avif"
import LockUSB from "../assets/img/LockUSB.avif"
import BrewFactory from "../assets/img/BrewFactory.avif"
import Homerpage from "../assets/img/homerpage.avif"
import RTXBuyer from "../assets/img/RTX5080BuyerBot.avif"
import tarealba from "../assets/img/tarealba.avif"
import businessCentral from "../assets/img/logos/bussiness_central.avif"
import { SiMongodb, SiNodedotjs, SiPython, SiHtml5, SiJavascript, SiCss, SiSocketdotio, SiMongoose, SiBootstrap, SiTelegram, SiDocker, SiPostgresql } from "@icons-pack/react-simple-icons";
import { IoIosDesktop, IoIosPeople, IoMdChatbubbles, IoMdLock, IoIosTimer } from "react-icons/io";
import { FaVolumeUp, FaEye, FaShieldAlt, FaUserShield, FaWindows, FaDatabase, FaTable, FaIndustry, FaServer, FaTelegramPlane, FaTicketAlt } from "react-icons/fa";
import { VscTerminalCmd, VscListSelection } from "react-icons/vsc";
import { TbApi } from "react-icons/tb";
import { BsArrowRepeat } from "react-icons/bs";
import { GiCardAceSpades } from "react-icons/gi";
import { MdStyle, MdAnimation } from "react-icons/md";
import { RiSpamFill } from "react-icons/ri";
import {
    MdOutlineDashboardCustomize,
    MdOutlineCalendarMonth,
    MdOutlineAssignmentTurnedIn,
    MdOutlineHomeWork,
    MdOutlinePersonSearch,
    MdOutlineSupportAgent,
    MdOutlineAirplaneTicket
} from "react-icons/md";


export const projectsFront = [
    {
        title: "BlackJack",
        slug: "blackjack",
        description: "Aplicación sencilla para jugar BlackJack",
        descriptionLong: "Primer proyecto de clase en el que empleamos el consumo de APIs externas. Mediante el uso una API REST para la obtención del mazo, implementé la lógica completa del juego incluyendo sistema de apuestas, cálculo dinámico de ases y puntuación y turnos de jugador y crupier.",
        img: blackJack,
        disponibilidad: "disponible",
        technologies: [
            { icon: SiHtml5, name: "HTML5" },
            { icon: SiJavascript, name: "JavaScript" },
            { icon: SiCss, name: "CSS" }
        ],
        technologiesLong: [
            { icon: SiHtml5, name: "HTML" },
            { icon: SiCss, name: "CSS" },
            { icon: SiJavascript, name: "Javascrcript" },
        ],
        features: [
            {
                icon: TbApi,
                color: "#ff2a6d",
                description: "Consumo de API externa"
            },
            {
                icon: BsArrowRepeat,
                color: "#f59e0b",
                description: "Manejo de promesas/async-await"
            },
            {
                icon: GiCardAceSpades,
                color: "#ffffff",
                description: "Motor de reglas para Blackjack"
            },
            {
                icon: MdStyle,
                color: "#b026ff",
                description: "Diseño Cyberpunk custom"
            },
            {
                icon: MdAnimation,
                color: "#ffea00",
                description: "Animaciones CSS puras"
            }
        ],
        githubUrl: "https://github.com/j-penarrubia/BlackJack",
        demoUrl: "https://blackjack-sytj.onrender.com"
    },
    {
        title: "Homer's webpage",
        slug: "homerswebpage",
        description: "Mítica página web creada por Homer Simpson",
        descriptionLong: `Réplica de la web creada por Homer Simpson en el episodio "The Computer Wore Menace Shoes" (temporada 12, ep. 6): una agresión total a los sentidos, perfecta para dominar filas y columnas de Bootstrap.\n\n "Lo normal es que tanto ruido fuera molesto, pero no lo es."\n- Homer J. Simpson`,
        img: Homerpage,
        disponibilidad: "disponible",
        technologies: [
            { icon: SiHtml5, name: "HTML5" },
            { icon: SiCss, name: "CSS" },
            { icon: SiJavascript, name: "Javascript" },
        ],
        technologiesLong: [
            { icon: SiHtml5, name: "HTML5" },
            { icon: SiCss, name: "CSS" },
            { icon: SiJavascript, name: "Javascript" },
            { icon: SiBootstrap, name: "Bootstrap" }
        ],
        features: [
            {
                icon: FaEye,
                color: "#00ff00",
                description: "Agresión visual"
            },
            {
                icon: FaVolumeUp,
                color: "#ff0000",
                description: "Agresión acústica"
            },
            {
                icon: SiBootstrap,
                color: "#7952b3",
                description: "Estilizado con Bootstrap"
            }
        ],
        githubUrl: "https://github.com/j-penarrubia/homersWebpage",
        demoUrl: "https://homerswebpage.onrender.com/"
    }
];

export const projectsBack = [{
    title: "CyberChat",
    slug: "cyberchat",
    description: "Chat en tiempo real cifrado de extremo a extremo",
    descriptionLong: "Aplicación de mensajería instantánea securizada bajo principios de arquitectura Zero-Knowledge a partir de la revisión de una práctica de clase sobre WebSockets. El sistema incluye autenticación de usuarios, una sala de chat global y mensajería privada 1 a 1.\n Como características de seguridad, se sanitizan las consultas en el servidor para prevenir ataques de inyección, la mensajería 1 a 1 implementa cifrado híbrido extremo a extremo (AES-GCM + RSA-OAEP) utilizando la Web Crypto API del navegador y las sesiones se gestionan de manera estricta. \n\n *USUARIOS DE PRUEBA* \n - user: Paco, pass: 12345 \n - user: Pepe, pass: 12345",
    img: cyberChat,
    disponibilidad: "disponible",
    technologies: [
        { icon: SiSocketdotio, name: "Socket.io", color: "#ffffff" },
        { icon: SiMongoose, name: "Mongoose" },
        { icon: SiMongodb, name: "MongoDB" }
    ],
    technologiesLong: [
        { icon: SiHtml5, name: "HTML" },
        { icon: SiCss, name: "CSS" },
        { icon: SiJavascript, name: "Javascript" },
        { icon: SiSocketdotio, name: "Socket.io", color: "#ffffff" },
        { icon: SiMongoose, name: "Mongoose" },
        { icon: SiNodedotjs, name: "Node.js" },
        { icon: SiMongodb, name: "MongoDB" }
    ],
    features: [
        {
            icon: IoIosDesktop,
            color: "#00e5ff",
            description: "Interfaz gráfica con temática cyberpunk y animaciones"
        },
        {
            icon: IoIosPeople,
            color: "#ff007f",
            description: "Gestión de sesiones de usuario y persistencia"
        },
        {
            icon: IoMdChatbubbles,
            color: "#00ff66",
            description: "Chat público global y privado 1 a 1"
        },
        {
            icon: IoMdLock,
            color: "#facc15",
            description: "Distribución segura de claves públicas desde base de datos"
        },
        {
            icon: FaDatabase,
            color: "#b0b0b0",
            description: "Almacenamiento client-side en IndexedDB"
        }
    ],
    githubUrl: "https://github.com/j-penarrubia/CyberChat",
    demoUrl: "https://cyberchat-m8ll.onrender.com",
    security: [
        { name: " Cifrado Híbrido end to end (AES-GCM + RSA)" },
        { name: " Contraseñas cifradas con Bcrypt + Salting" },
        { name: " Cookie Security (HttpOnly + Secure + SameSite)" },
        { name: " NoSQL Injection Prevention (mongoSanitize)" }
    ]
},
{
    title: "BrewFactory",
    slug: "bc-brewfactory",
    description: "Proyecto de personalización de Business Central para una fábrica de cerveza",
    descriptionLong: "Proyecto de Business Central que simula la personalización para una fábrica de cerveza. Incluye tanto páginas y tablas nuevas como extensiones de ambas, además de control de borrado mediante suscripción o extensión de tabla. También se incluyen CodeUnits para funciones reutilizables desde todo el proyecto para trabajar con tipos Blob o para funciones específicas como el control de borrado, la generación de reportes personalizados y filtrado de tipo de producto por la nueva categoría.",
    img: BrewFactory,
    disponibilidad: "disponible",
    technologies: [{
        icon: () => (
            <img
                src={businessCentral}
                alt="BC"
                style={{ width: 28, height: 28 }}
            />
        ),
        name: "Business Central"
    }],
    technologiesLong: [
        {
            icon: () => (
                <img
                    src={businessCentral}
                    alt="BC"
                    style={{ width: 28, height: 28 }}
                />
            ),
            name: "Business Central"
        }
    ],
    features: [
        {
            icon: FaIndustry,
            color: "#FFD700",
            description: "Role Center personalizado BrewFactory"
        },
        {
            icon: VscListSelection,
            color: "#059669",
            description: "Control de borrado personalizable"
        },
        {
            icon: FaTable,
            color: "#4F46E5",
            description: "Tablas nuevas y extensiones"
        },
        {
            icon: VscTerminalCmd,
            color: "#F59E0B",
            description: "Codeunits lógicas globales"
        },
        {
            icon: FaWindows,
            color: "#00D4FF",
            description: "Integración nativa Business Central"
        }
    ],
    githubUrl: "https://github.com/j-penarrubia/BC_BrewFactory"
},
{
    title: "Gestiones Tarealba",
    slug: "tarealba",
    description: "API para la gestión de incidencias en inmuebles",
    descriptionLong: "Desarrollado como proyecto del Grado de Desarrollo Web, este sistema conecta inquilinos, propietarios y trabajadores para gestionar incidencias. \nActualmente me encuentro evolucionando la arquitectura original: estoy migrando el sistema monolítico hacia una arquitectura de servicios desacoplados. La próxima versión incluirá un frontend modernizado desarrollado en Angular y un backend enfocado en la ciberseguridad mediante técnicas de bastionado.\n Mientras finalizo la nueva versión, puedes explorar el proyecto original utilizando las siguientes credenciales de prueba:\n\n --User: Admin; Pass: 12345\n--User: Paquito, Pass: 12345\n--User: Alberto, Pass: 12345",
    img: tarealba,
    disponibilidad: "En Revisión",
    technologies: [
        { icon: SiNodedotjs, name: "Node.js" },
        { icon: SiPostgresql, name: "PostgreSQL" },
    ],
    technologiesLong: [
        { icon: SiHtml5, name: "HTML" },
        { icon: SiCss, name: "CSS" },
        { icon: SiJavascript, name: "Javascript" },
        { icon: SiPostgresql, name: "PostgreSQL" },
        { icon: SiNodedotjs, name: "Node.js" }
    ],
    features: [
        {
            icon: FaUserShield,
            color: "#7C3AED",
            description: "Panel por roles"
        },
        {
            icon: MdOutlineCalendarMonth,
            color: "#06B6D4",
            description: "Calendario de trabajadores"
        },
        {
            icon: MdOutlineAssignmentTurnedIn,
            color: "#22C55E",
            description: "Seguimiento de incidencias"
        },
        {
            icon: MdOutlineHomeWork,
            color: "#F97316",
            description: "Asignación de viviendas"
        },
        {
            icon: MdOutlineAirplaneTicket,
            color: "#EAB308",
            description: "Registro y gestión de tickets"
        },
        {
            icon: MdOutlinePersonSearch,
            color: "#3B82F6",
            description: "Asignación de responsables"
        },
        {
            icon: MdOutlineDashboardCustomize,
            color: "#EC4899",
            description: "Dashboard operativo"
        },
        {
            icon: MdOutlineSupportAgent,
            color: "#EF4444",
            description: "Soporte y resolución centralizada"
        }
    ],
    githubUrl: "https://github.com/j-penarrubia/TFG_FIX",
    demoUrl: "https://tarealba-tfg.onrender.com/"
}];

export const projectsTools = [{
    title: "LockUSB Switch",
    slug: "lockusb-switch",
    description: "Herramienta que activa o desactiva el automontaje de USB en Windows 11",
    descriptionLong: "LockUSB Switch es una herramienta desktop que permite activar/desactivar el automontaje de dispositivos USB en Windows. Surgió durante clases de forense digital, donde necesitaba analizar dispositivos de almacenamiento en máquinas virtuales.\nEl problema: Windows modifica automáticamente el hash global del USB al automontar (creando thumbs.db, prefetches, etc...), invalidando la cadena de custodia.\n\nEsta solución preserva la integridad forense mientras mantiene la usabilidad diaria.",
    img: LockUSB,
    disponibilidad: "disponible",
    technologies: [
        { icon: SiPython, name: "Python" }
    ],
    technologiesLong: [
        { icon: SiPython, name: "Python" }
    ],
    features: [
        { icon: IoIosDesktop, color: "#ec4899", description: "Interfaz gráfica" },
        {
            icon: FaShieldAlt,
            color: "#10b981",
            description: "Hardening OS y prevención de BadUSB"
        },
        {
            icon: FaUserShield,
            color: "#f59e0b",
            description: "Auto-elevación de privilegios (UAC)"
        },
        {
            icon: FaWindows,
            color: "#3b82f6",
            description: "Modificación del Registro y Servicios"
        },
        {
            icon: VscTerminalCmd,
            color: "#ec4899",
            description: "Build automatizada con PowerShell"
        }
    ],
    githubUrl: "https://www.google.es"
},
{
    title: "RTX5080 BuyerBot",
    slug: "RTX5080_BuyerBot",
    description: "Bot de monitorización de disponibilidad de tarjetas gráficas",
    descriptionLong: "En clase, cuando tratábamos el tema del web scraping, monté un pequeño bot que scrapeaba y compraba automáticamente una tarjeta gráfica. \n Revisando el proyecto, y aprovechando que últimamente me he estado interesando por docker y su funcionamiento, me decidí a dockerizar el proyecto dividiéndolo en 3 contenedores, uno común que actúa como base de datos, otro que scrapea la web en busca de tarjetas disponibles y el tercero que comprueba su disponibilidad y envía notificación por telegram en caso de estarlo. \n\n El bot original realizaba la compra automáticamente, pero viéndolo con perspectiva, no me parece lo más seguro actualmente.",
    img: RTXBuyer,
    disponibilidad: "disponible",
    technologies: [
        { icon: SiDocker, name: "Docker" },
    ],
    technologiesLong: [
        { icon: SiDocker, name: "Docker" },
        { icon: SiPython, name: "Python" },
        { icon: SiMongodb, name: "MongoDB" },
        { icon: SiTelegram, name: "Telegram" }
    ],
    features: [
        {
            icon: FaEye,
            color: "#ff9203",
            description: "Monitorización 24/7 GPUs RTX 5080"
        },
        {
            icon: IoIosDesktop,
            color: "#ff9203",
            description: "Dashboard noVNC Headless Chrome"
        },
        {
            icon: FaTelegramPlane,
            color: "#0088CC",
            description: "Alertas de disponibilidad por Telegram"
        },
        {
            icon: SiDocker,
            color: "#2496ED",
            description: "Docker Compose Production-Ready"
        },
        {
            icon: FaServer,
            color: "#00d4aa",
            description: "Database con índices optimizados"
        },
        {
            icon: IoIosTimer,
            color: "#00ffd5",
            description: "Vigilancia inteligente con cooldown de 1h"
        },
        {
            icon: RiSpamFill,
            color: "#ff0000",
            description: "Anti-spam caché"
        },
    ],
    githubUrl: "https://github.com/j-penarrubia/GPU-Hunter",
},];

export const allProjects = [...projectsFront, ...projectsBack, ...projectsTools];